/* eslint-disable react/prop-types */
import React from 'react';
import { quotaUsagePercent, quotaResetHint } from '../../services/aiInsightsApi';

/**
 * Token Usage meter — Lessons Learned Ask Evans sister:
 * Left: "Token Usage: N% used this month" + reset hint
 * Right: thin progress bar
 *
 * Shows 0% when API reports used=0 / percent=0.
 * When quota has not loaded yet, still shows 0% (LL sister) with muted fill.
 */
const SpacerLogAiQuotaBar = ({ quota }) => {
  const pct = quotaUsagePercent(quota);
  const known = pct != null;
  const shown = known ? pct : 0;
  return (
    <div
      className={`spacer-ask-evans__quota${known ? '' : ' spacer-ask-evans__quota--pending'}`}
    >
      <div className="spacer-ask-evans__quota-text">
        <span className="spacer-ask-evans__quota-label">
          Token Usage: <strong>{shown}%</strong> used this month
        </span>
        <span className="spacer-ask-evans__quota-hint">{quotaResetHint(quota)}</span>
      </div>
      <div
        className="spacer-ask-evans__quota-track"
        role="progressbar"
        aria-valuenow={shown}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-label={`Token usage ${shown}% this month`}
      >
        <div className="spacer-ask-evans__quota-fill" style={{ width: `${shown}%` }} />
      </div>
    </div>
  );
};

export default SpacerLogAiQuotaBar;
